// import React from "react";
// import styles from "./styles.module.css";
// const VideoPlayer = ({
//   video,
//   id,
//   rId,
//   theme,
//   style = null,
//   height = null,
//   position = null,
//   paddingTop = null,
//   marginTop = null,
//   vclass = null,
//   clickFunction = null,
// }) => {
//   const videoHandler = (e) => {
//     // console.log({ aa: e.target.getAttribute("data-vid") });
//     if (clickFunction) {
//       if (e.target.getAttribute("data-vid")) {
//         let video = document.getElementById(e.target.getAttribute("data-vid"));
//         document.querySelectorAll(".testVideo1").forEach((vid) => {
//           let a = vid.closest(".react-multi-carousel-item--active");
//           let b = vid.getAttribute("data-rid");
//           if (a) {
//             if (vid.paused) {
//               // console.log("a1", a);
//               vid.play();
//               let c = vid.previousSibling.id;
//               if (c == "playBtn-mob-" + b) {
//                 if (
//                   !vid.paused &&
//                   vid.previousElementSibling.classList.contains(c)
//                 ) {
//                   vid.previousElementSibling.style.display = "none";
//                 }
//               }
//             } else {
//               vid.pause();
//               let c = vid.previousSibling.id;
//               if (
//                 vid.paused &&
//                 vid.previousElementSibling.classList.contains(c)
//               ) {
//                 vid.previousElementSibling.style.display = "block";
//               }
//             }
//           }
//         });
//       }
//     } else {
//       if (e.target.getAttribute("data-vid")) {
//         let video = document.getElementById(e.target.getAttribute("data-vid"));
//         if (video.paused) {
//           video
//             .play()
//             .then((Response) => {
//               console.log({ Response });
//             })
//             .catch((err) => {
//               console.log(err);
//             });
//           document.getElementById(
//             e.target.getAttribute("data-id")
//           ).style.display = "none";
//         } else {
//           let pausedStatus = video.pause();
//           // console.log({ pausedStatus });
//           document.getElementById(
//             e.target.getAttribute("data-id")
//           ).style.display = "block";
//         }
//       }
//     }
//   };
//   return (
//     <div className={styles.holder}>
//       <div
//         className={`${styles.playerHolder} ${"playBtn-" + id} player`}
//         id={`playBtn-${id}`}
//         data-id={`playBtn-${id}`}
//         data-vid={`video-${id}`}
//         onClick={videoHandler}
//         style={style ? style : { backgroundColor: theme }}
//       ></div>
//       <video
//         className={`${
//           vclass ? styles.videoEmbbed1 : styles.videoEmbbed
//         } testVideo1`}
//         style={
//           (position && { position: "unset", height: height },
//           paddingTop && { paddingTop: paddingTop },
//           marginTop && { marginTop: marginTop })
//         }
//         poster={video.poster}
//         frameBorder="0"
//         data-id={`playBtn-${id}`}
//         data-vid={`video-${id}`}
//         data-rid={`${rId ? rId : ""}`}
//         id={`video-${id}`}
//         onClick={videoHandler}
//         allowFullScreen=""
//         mozallowfullscreen=""
//         webkitallowfullscreen=""
//         oallowfullscreen=""
//         msallowfullscreen=""
//         src={video.src}
//       >
//         <track src="" kind="captions" />
//       </video>
//     </div>
//   );
// };
// export default VideoPlayer;
import React from "react";
import { Helmet } from "react-helmet-async";
import styles from "./styles.module.css";

const VideoPlayer = ({
  video,
  id,
  rId,
  theme,
  style = null,
  height = null,
  position = null,
  paddingTop = null,
  marginTop = null,
  vclass = null,
  clickFunction = null,
  title = "",
  description = "",
  uploadDate = "",
  duration = "",
  thumbnailUrl = "",
  watchPageUrl = "",
  embedUrl = "",
  contentUrl = "",
  keyMoments = [],
  isLive = false,
  liveStartDate = "",
  liveEndDate = "",
  viewCount = 0,
  addStructuredData = true,
}) => {
  /* ---------------- SEO STRUCTURED DATA (ONLY HEAD) ---------------- */

  const generateStructuredData = () => {
    if (!title || !description || !addStructuredData) return null;

    const data = {
      "@context": "https://schema.org",
      "@type": "VideoObject",
      name: title,
      description: description,
      thumbnailUrl: thumbnailUrl || video.poster,
      uploadDate: uploadDate || "2025-12-23T09:00:35Z",
      contentUrl: contentUrl || video.src,
      duration: duration || undefined,
      embedUrl: embedUrl || undefined,
      url: watchPageUrl || undefined,
    };

    if (viewCount > 0) {
      data.interactionStatistic = {
        "@type": "InteractionCounter",
        interactionType: { "@type": "WatchAction" },
        userInteractionCount: viewCount,
      };
    }

    if (keyMoments && keyMoments.length > 0) {
      data.hasPart = keyMoments.map((moment) => ({
        "@type": "Clip",
        name: moment.name,
        startOffset: moment.startOffset,
        endOffset: moment.endOffset,
        url: moment.url,
      }));

      if (watchPageUrl) {
        data.potentialAction = {
          "@type": "SeekToAction",
          target: `${watchPageUrl}?t={seek_to_second_number}`,
          "startOffset-input": "required name=seek_to_second_number",
        };
      }
    }

    return data;
  };

  const structuredData = generateStructuredData();

  /* ---------------- ORIGINAL VIDEO HANDLER (UNCHANGED) ---------------- */

  const videoHandler = (e) => {
    if (clickFunction) {
      if (e.target.getAttribute("data-vid")) {
        document.querySelectorAll(".testVideo1").forEach((vid) => {
          let a = vid.closest(".react-multi-carousel-item--active");
          let b = vid.getAttribute("data-rid");
          if (a) {
            if (vid.paused) {
              vid.play();
              let c = vid.previousSibling.id;
              if (
                c === "playBtn-mob-" + b &&
                !vid.paused &&
                vid.previousElementSibling.classList.contains(c)
              ) {
                vid.previousElementSibling.style.display = "none";
              }
            } else {
              vid.pause();
              let c = vid.previousSibling.id;
              if (
                vid.paused &&
                vid.previousElementSibling.classList.contains(c)
              ) {
                vid.previousElementSibling.style.display = "block";
              }
            }
          }
        });
      }
    } else {
      if (e.target.getAttribute("data-vid")) {
        let video = document.getElementById(e.target.getAttribute("data-vid"));
        if (video.paused) {
          video.play();
          document.getElementById(
            e.target.getAttribute("data-id")
          ).style.display = "none";
        } else {
          video.pause();
          document.getElementById(
            e.target.getAttribute("data-id")
          ).style.display = "block";
        }
      }
    }
  };

  /* ---------------- RENDER ---------------- */

  return (
    <>
      {/* ---------- SEO ONLY (NO BODY SCHEMA) ---------- */}
      {structuredData && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>

          <meta name="robots" content="max-video-preview:-1" />
          <meta property="og:type" content="video.other" />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={thumbnailUrl || video.poster} />
          <meta property="og:video" content={contentUrl || video.src} />
          <meta
            property="og:video:secure_url"
            content={contentUrl || video.src}
          />

          <meta name="twitter:card" content="player" />
          <meta name="twitter:title" content={title} />
          <meta name="twitter:description" content={description} />
          <meta name="twitter:image" content={thumbnailUrl || video.poster} />
        </Helmet>
      )}

      {/* ---------- UI (UNCHANGED) ---------- */}
      <div className={styles.holder}>
        <div
          className={`${styles.playerHolder} ${"playBtn-" + id} player`}
          id={`playBtn-${id}`}
          data-id={`playBtn-${id}`}
          data-vid={`video-${id}`}
          onClick={videoHandler}
          style={style ? style : { backgroundColor: theme }}
        ></div>

        <video
          className={`${
            vclass ? styles.videoEmbbed1 : styles.videoEmbbed
          } testVideo1`}
          style={
            (position && { position: "unset", height: height },
            paddingTop && { paddingTop: paddingTop },
            marginTop && { marginTop: marginTop })
          }
          poster={video.poster}
          frameBorder="0"
          data-id={`playBtn-${id}`}
          data-vid={`video-${id}`}
          data-rid={`${rId ? rId : ""}`}
          id={`video-${id}`}
          onClick={videoHandler}
          allowFullScreen=""
          mozallowfullscreen=""
          webkitallowfullscreen=""
          oallowfullscreen=""
          msallowfullscreen=""
          playsInline
          preload="metadata"
          src={video.src}
        >
          <track src="" kind="captions" />
        </video>
      </div>
    </>
  );
};

export default VideoPlayer;
